import React, { useCallback, useEffect, useState } from 'react'

import { FairUse } from 'src/styled'
import { Text } from '@sendoutcards/quantum-design-ui'
import { GetFairUseMarketingContent } from 'src/graphql'
import { performOperation } from 'src/app/api'

interface Props {
  messages: string[]
}

const Disclaimer: React.FC<Props> = props => {
  const { messages } = props
  const [fairUsePolicyLink, setFairUsePolicyLink] = useState<
    string | undefined
  >()

  const getFairUsePolicy = useCallback(() => {
    performOperation(GetFairUseMarketingContent(), result => {
      if (!result.error && result.value) {
        setFairUsePolicyLink(result.value.fairUsePolicyLink.url)
      }
    })
  }, [setFairUsePolicyLink])
  useEffect(() => {
    getFairUsePolicy()
  }, [getFairUsePolicy])

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {messages &&
        messages.map((message, index) => (
          <Text key={index} type="footnote">
            {message}
          </Text>
        ))}
      <Text type="footnote">
        All Heartfelt Prompting Cards are subject to the {''}
        <FairUse
          target="blank"
          href={fairUsePolicyLink}
          onClick={e => e.stopPropagation()}
        >
          <Text type="footnote" color="primaryBrand">
            Fair Use Policy
          </Text>
        </FairUse>{' '}
        and all prices are in USD.
      </Text>
      <Text type="footnote">
        Cards included in the monthly subscriptions do not roll over and are
        only good during the monthly subscription period.
      </Text>
      <Text type="footnote">
        Cards included in the card packages do not roll over and are only good
        during the period of the package. Please refer to card packages for term
        details.
      </Text>
    </div>
  )
}

export default Disclaimer
